/**
 * 2020/4/1 - 15:13
 * @author jiabinbin
 * @Email 425605679@qq.com
 * @Description:
 *
 */
import { createNamespacedHelpers } from 'vuex'
export default function getVuexWithNameSpace (name) {
  return createNamespacedHelpers(name)
}
